import { ISuggestionEntry } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/Interfaces";
import {
  getBrandsHeader,
  getRecentSearchesHeader,
  getSuggestedTermsHeader,
  getNaturalLanguageSearchEmptyStateHeader,
  getTrendingBrandsHeader,
  getTrendingSearchesHeader,
} from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/consts";
import { getRetailer } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getRetailer";
import { ISearchRequestReferrer } from "@faire/web-api--source/indigofair/data/ISearchRequestReferrer";
import { ISearchSuggestionResponse } from "@faire/web-api--source/indigofair/data/ISearchSuggestionResponse";
import { StrictLocalizeFunction } from "@faire/web/common/localization/localize";

export const shouldShowSearchRecommendations = (
  searchRecommendations:
    | ISearchSuggestionResponse.ISearchRecommendation[]
    | undefined
) => searchRecommendations && searchRecommendations?.length > 0;

export const getSuggestionUrl = (url: string) => {
  if (!url.startsWith("/")) {
    const retailerToken = getRetailer()?.token;
    const urlPrefix = retailerToken ? `/retailer/${retailerToken}` : "/";
    url = `${urlPrefix}${url}`;
  }
  return url.replace("//", "/");
};

export const getContainerName = (
  sectionHeader: string,
  strictLocalize: StrictLocalizeFunction
): string => {
  // TODO:: (kiminno) Refactor the suggestions to return the container names from BE instead.
  const DEFAULT_CONTAINER_NAME = "suggestions_default_container_name";
  const SEARCH_SUGGESTION_TRENDING_SEARCHES_CONTAINER_NAME =
    "SUGGESTIONS_TRENDING_SEARCHES";
  const RECENT_SEARCHES_CONTAINER_NAME = "SUGGESTIONS_RECENT_SEARCHES";
  const SEARCH_SUGGESTION_BRAND_SUGGESTIONS = "SUGGESTIONS_BRANDS";
  const SEARCH_SUGGESTION_QUERY_SUGGESTIONS = "SUGGESTIONS_SEARCH_QUERIES";

  switch (sectionHeader) {
    case getRecentSearchesHeader(strictLocalize):
      return RECENT_SEARCHES_CONTAINER_NAME;
    case getSuggestedTermsHeader(strictLocalize):
      return SEARCH_SUGGESTION_QUERY_SUGGESTIONS;
    case getTrendingSearchesHeader(strictLocalize):
      return SEARCH_SUGGESTION_TRENDING_SEARCHES_CONTAINER_NAME;
    case getBrandsHeader(strictLocalize):
      return SEARCH_SUGGESTION_BRAND_SUGGESTIONS;
    case getTrendingBrandsHeader(strictLocalize):
      return SEARCH_SUGGESTION_BRAND_SUGGESTIONS;
    case getNaturalLanguageSearchEmptyStateHeader(strictLocalize):
      return ISearchRequestReferrer.SearchRequestReferrerType
        .SUGGESTIONS_NATURAL_LANGUAGE_SEARCH_EMPTY_STATE;
    default:
      return DEFAULT_CONTAINER_NAME;
  }
};

export const getSuggestionEventToken = (
  sectionHeader: string,
  suggestion: ISuggestionEntry,
  strictLocalize: StrictLocalizeFunction
): string | undefined => {
  switch (sectionHeader) {
    case getRecentSearchesHeader(strictLocalize): {
      return `${suggestion.label}`;
    }
    case getSuggestedTermsHeader(strictLocalize): {
      return `${suggestion.searchData.query}`;
    }
    case getTrendingSearchesHeader(strictLocalize): {
      return `${suggestion.label}`;
    }
    case getBrandsHeader(strictLocalize): {
      return `${suggestion.searchData.token}`;
    }
    case getTrendingBrandsHeader(strictLocalize): {
      return `${suggestion.label}`;
    }
    case getNaturalLanguageSearchEmptyStateHeader(strictLocalize): {
      return `${suggestion.label}`;
    }
    default:
      return "";
  }
};
